import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';
import MaterialTable from 'material-table';

// components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col } from "reactstrap";

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// views
import GuiaDestinacaoForm from "./GuiaDestinacaoForm.jsx";

// helpers
import { showMessage, showQuestion } from "../../helpers/message.js";
import { getSessionCookie } from "../../helpers/cookies.js";
import { formateDate, formateDateApi } from "../../helpers/formats.js";

// api
import guiadestinacao_api from "../../api/guiadestinacao_api.js";

//Context
import { useAuth } from "../../context/auth.js";

export default function GuiaDestinacaoLista() {
  const { session, setLoading } = useAuth();

  const { register, handleSubmit, errors, getValues } = useForm({ mode: "onBlur" });

  const [list_table, set_list_table] = useState([]);
  const [rowEdit, set_rowEdit] = useState(null);
  const [showDetail, set_showDetail] = useState(false);

  const handleAdd = () => {
    set_rowEdit(null);
    set_showDetail(true);
  }

  const handleEdit = (rowData) => {
    set_rowEdit(rowData);
    set_showDetail(true);
  }

  const handleDelete = (rowData) => {
    if (formateDateApi(rowData.dataHora) != formateDateApi(new Date())) {
      showMessage("Aviso", "Só é permitido excluir guias com a data de hoje", 'error', null);
      return;
    }
    showQuestion("Atenção", "Tem certeza que deseja excluir a guia?", "", function (result) {
      if (result) {
        setLoading(true);
        guiadestinacao_api.delete(rowData.guiaDestinacaoId).then(result => {
          setLoading(false);
          if (result.status !== 200) {
            showMessage("Aviso", result.message, 'error', null);
          }
          else {
            showMessage("Aviso", "Operação executada com sucesso", "success", function () {
              let data = getValues();
              loadList(data);
            });
          }
        });
      }
    });
  }

  const handleReturn = () => {
    set_rowEdit(null);
    set_showDetail(false);

    let data = getValues();
    loadList(data);
  }

  const loadList = (data) => {
    let json_submit = {
      localId: session.localId,
      dataInicial: formateDateApi(data.dataInicial),
      dataFinal: formateDateApi(data.dataFinal)
    }
    setLoading(true);
    guiadestinacao_api.getList(json_submit).then(result => {
      setLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  const onSubmit = (data) => {
    loadList(data);
  }

  useEffect(() => {
    let data = getValues();
    loadList(data);
  }, []);

  return (
    <>
      <div className={showDetail ? "d-none" : "content"}>
        <Row>
          <Col md="12">
            <button type="button" onClick={handleAdd} className="btn btn-secundary"><i className="fa fa-plus"></i>  Nova Guia</button>
            <Card>
              <CardHeader>
                <h4 className="titleCard">Lista de Guias de Destinação</h4>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col lg="3" md="3" sm="6">
                      <FormGroup>
                        <label className="form-control-label">Data Inicial:</label>
                        <Input className="form-control"
                          autocomplete="off"
                          type="date"
                          defaultValue={formateDateApi(new Date())}
                          name="dataInicial"
                          innerRef={register({ required: true })}
                        />
                        {errors.dataInicial && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="3" md="3" sm="6">
                      <FormGroup>
                        <label className="form-control-label">Data Final:</label>
                        <Input className="form-control"
                          autocomplete="off"
                          type="date"
                          defaultValue={formateDateApi(new Date())}
                          name="dataFinal"
                          innerRef={register({ required: true })}
                        />
                        {errors.dataFinal && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                      </FormGroup>
                    </Col>
                    <Col lg="3" md="3" sm="12">
                      <Button color="info" className="btn-mobile mt-4" type="submit"><i className="fas fa-search"></i> Pesquisar</Button>
                    </Col>
                  </Row>
                  <MaterialTable style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                      { title: 'Número da Guia', field: 'numeroGuia' },
                      { title: 'Transportador', field: 'identificacaoTransportador' },
                      { title: 'Destino', field: 'identificacaoDestino' },
                      { title: 'Data/Hora', field: 'dataHora', render: rowData => formateDate(rowData.dataHora) },
                    ]}
                    data={list_table}
                    isLoading={false}
                    options={{ ...table_style, filtering: false, exportButton: true }}
                    actions={[
                      {
                        icon: 'search',
                        tooltip: 'Visualizar Registro',
                        onClick: (event, rowData) => handleEdit(rowData)
                      },
                      {
                        icon: 'close',
                        tooltip: 'Remover Registro',
                        onClick: (event, rowData) => handleDelete(rowData)
                      }
                    ]}
                    localization={table_translate}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showDetail &&
        <GuiaDestinacaoForm
          item={rowEdit}
          handleReturn={handleReturn}
        />
      }

    </>

  );
}